module.exports = __webpack_public_path__ + "img/pulsetic-logo.186aed09.svg";